import { QueryClient } from '@tanstack/react-query';

// Single shared instance — must be imported (not re-instantiated) by anything
// that needs to read/invalidate the cache outside of a React component tree
// (e.g. clearing cached queries on logout from useToken.ts).
export const queryClient = new QueryClient();
